import React, { useEffect, useState } from "react";
import beautyOfJseon from "../../assets/images/website-images/beauty-of-jseon.png";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router-dom";
import HealthPackageTabCard from "./HomePage/Cards/HealthPackageTabCard";
import httpRequest from "src/helpers/httpRequest";
import { toast } from "react-toastify";
import { convertToKebabCase } from "src/helpers/helperFunctions";
import DotsLoaderAnimation from "../Loaders/DotsLoaderAnimation";
import { HealthPackage } from "src/types/GlobalInterfaces";


interface HealthPackageHoveredTabProps {
  id: string;
  style: React.CSSProperties;
  onClose: () => void;
  data: HealthPackage[];
  setData: React.Dispatch<React.SetStateAction<HealthPackage[]>>;
}

const HealthPackageHoveredTab: React.FC<HealthPackageHoveredTabProps> = ({
  id,
  style,
  onClose,
  data,
  setData,
}) => {
  const [loader, setLoader] = useState<boolean>(false);

  const fetchPackages = async () => {
    if (data.length === 0) {
      setLoader(true);
    }
    const { res, err } = await httpRequest<{ documents: HealthPackage[] }>({
      path: "/product/all-diagnostic-packages?page=1&limit=7",
    });
    if (res) {
      setData(res.documents || []);
    } else {
      toast(err, { type: "error" });
    }
    setLoader(false);
  };

  useEffect(() => {
    fetchPackages();
  }, []);

  const navigate = useNavigate();

  return (
    <div id={id} className="relative p-1 pt-0 h-fit min-h-[250px] xl:min-h-[300px] w-full">
      <div
        style={style}
        className="min-w-full p-2 2xl:p-4 rounded-br-md rounded-bl-md bg-white shadow relative"
      >
        <div className="flex justify-between items-end">
          <div>
            <h2 className="font-Lexend-SemiBold font-size-35px theme-color-green">
              Health Packages
            </h2>
            <p className="font-size-18px font-Poppins-Regular under-dropdown-text">
              Explore all the packages
            </p>
          </div>
          <div
            className="font-size-16px font-Poppins-SemiBold theme-color-green-3f underline cursor-pointer"
            onClick={() => {
              onClose();
              navigate("/health-packages");
            }}
            id="health-package-hovered-tab-view-all-btn"
          >
            View All
          </div>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-3 gap-2 xl:gap-4 mt-2 xl:mt-4">
          {loader ? (
            <div className="flex w-full col-span-full justify-center items-center h-[150px]">
              <DotsLoaderAnimation />
            </div>
          ) : Array.isArray(data) && data?.length > 0 ? (
            data
              .slice(0, 6)
              .map((item, index) => (
                <HealthPackageTabCard onClose={onClose} key={index} data={item} id={`tab-health-package-${index}`} />
              ))
          ) : (
            <div className="flex w-full col-span-full justify-center items-center h-[150px]">
              <p className="font-size-18px font-Poppins-Regular theme-grey-type">
                No Health Packages Found
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default HealthPackageHoveredTab;
